import React, { useEffect } from 'react';
import { Stack } from '@mui/material';
import { logError } from 'utils/logger';
import { CurrencyInputField } from 'components/form';
import { useFormContext, useWatch } from 'react-hook-form';

import { DealSheetFormValues, LineItemSection } from '../types';

interface Props {
  rowIndex: number;
  section: LineItemSection;
}

export const LineItemCapsCell = ({ rowIndex, section }: Props) => {
  const { control, trigger, formState } = useFormContext<DealSheetFormValues>();

  const min = useWatch({ control, name: `${section}.${rowIndex}.cap.min` });
  const max = useWatch({ control, name: `${section}.${rowIndex}.cap.max` });

  useEffect(() => {
    if (!formState.isDirty) return;
    trigger([`${section}.${rowIndex}.cap.min`, `${section}.${rowIndex}.cap.max`]).catch(logError);
  }, [min, max, trigger, section, rowIndex, formState.isDirty]);

  return (
    <Stack gap="0.5rem">
      <CurrencyInputField
        label="Min"
        allowNegative
        control={control}
        name={`${section}.${rowIndex}.cap.min`}
        textFieldProps={{ variant: 'outlined' }}
      />

      <CurrencyInputField
        label="Max"
        allowNegative
        control={control}
        name={`${section}.${rowIndex}.cap.max`}
        textFieldProps={{ variant: 'outlined' }}
      />
    </Stack>
  );
};
